import { createRef, MutableRefObject, useMemo } from 'react';

export function useRefs<T>(numberOfRefs: number): MutableRefObject<T>[] {
  return useMemo(
    () => new Array(numberOfRefs).fill(null).map(() => createRef<T>()),
    []
  );
}
